<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  name: "teamPerformanceAdd",
  components: { breadcrumbs },
  data() {
    return {
      form: {
        level: 1
      }
    };
  },
  methods: {
    cancel() {
      this.$router.back();
    },
    sure() {}
  }
};
</script>

<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.back()"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!-- 表单查询 -->
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item label="团队级别" required>
        <el-radio-group v-model="form.level">
          <el-radio :label="1">1级</el-radio>
          <el-radio :label="2">2级</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="团队名称">
        <el-input
          v-model="form.userName"
          placeholder="请输入团队名称"
          clearable
        ></el-input>
      </el-form-item>
      <!--      1级内容-->
      <template v-if="form.level === 1">
        <el-form-item label="销售经理">
          <el-card shadow="never">
            <el-form-item label="姓名">
              <el-select
                v-model="form.status"
                placeholder="请选择销售经理"
                clearable
                filterable
              >
                <el-option label="正常" :value="0"></el-option>
                <el-option label="冻结" :value="1"></el-option>
                <el-option label="锁定" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="个人绩效比例">
              <el-input-number
                v-model="form.userName"
                placeholder="请输入个人绩效比例"
              ></el-input-number
              >&nbsp;&nbsp;%
            </el-form-item>
            <el-form-item label="团队绩效比例">
              <el-input-number
                v-model="form.userName"
                placeholder="请输入团队绩效比例"
              ></el-input-number
              >&nbsp;&nbsp;%
            </el-form-item>
            <el-form-item label="新用户开卡奖励">
              <el-input-number
                v-model="form.userName"
                placeholder="请输入新用户开卡奖励"
              ></el-input-number
              >&nbsp;&nbsp;元
            </el-form-item>
          </el-card>
        </el-form-item>
        <el-form-item label="组长">
          <el-card shadow="never">
            <el-form-item label="姓名">
              <el-select
                v-model="form.status"
                placeholder="请选择销售经理"
                clearable
                filterable
              >
                <el-option label="正常" :value="0"></el-option>
                <el-option label="冻结" :value="1"></el-option>
                <el-option label="锁定" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="个人绩效比例">
              <div>
                <el-input-number
                  v-model="form.userName"
                  placeholder="请输入个人绩效比例"
                ></el-input-number
                >&nbsp;&nbsp;%
              </div>
              <div style="color:var(--danger);">已设置组长个人绩效比例范围0~10%</div>
              <!--              管理列表设置获取-->
            </el-form-item>
            <el-form-item label="团队绩效比例">
              <div>
                <el-input-number
                  v-model="form.userName"
                  placeholder="请输入团队绩效比例"
                ></el-input-number
                >&nbsp;&nbsp;%
              </div>
              <div style="color:var(--danger);">已设置组长团队绩效比例范围0~10%</div>
            </el-form-item>
            <el-form-item label="新用户开卡奖励">
              <div>
                <el-input-number
                  v-model="form.userName"
                  placeholder="请输入新用户开卡奖励"
                ></el-input-number
                >&nbsp;&nbsp;元
              </div>
              <div style="color:var(--danger);">
                已设置组长新用户开卡奖励范围0~10元
              </div>
            </el-form-item>
          </el-card>
        </el-form-item>
      </template>
      <!--      2级内容-->
      <template v-if="form.level === 2">
        <el-form-item label="销售组长">
          <el-card shadow="never">
            <el-form-item label="姓名">
              <el-select
                v-model="form.status"
                placeholder="请选择销售经理"
                clearable
                filterable
              >
                <el-option label="正常" :value="0"></el-option>
                <el-option label="冻结" :value="1"></el-option>
                <el-option label="锁定" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="个人绩效比例">
              <el-input-number
                v-model="form.userName"
                placeholder="请输入个人绩效比例"
              ></el-input-number
              >&nbsp;&nbsp;%
            </el-form-item>
            <el-form-item label="团队绩效比例">
              <el-input-number
                v-model="form.userName"
                placeholder="请输入团队绩效比例"
              ></el-input-number
              >&nbsp;&nbsp;%
            </el-form-item>
            <el-form-item label="新用户开卡奖励">
              <el-input-number
                v-model="form.userName"
                placeholder="请输入新用户开卡奖励"
              ></el-input-number
              >&nbsp;&nbsp;元
            </el-form-item>
          </el-card>
        </el-form-item>
        <el-form-item label="组员">
          <el-card shadow="never">
            <el-form-item label="姓名">
              <el-select
                v-model="form.status"
                placeholder="请选择销售经理"
                clearable
                filterable
              >
                <el-option label="正常" :value="0"></el-option>
                <el-option label="冻结" :value="1"></el-option>
                <el-option label="锁定" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="个人绩效比例">
              <div>
                <el-input-number
                  v-model="form.userName"
                  placeholder="请输入个人绩效比例"
                ></el-input-number
                >&nbsp;&nbsp;%
              </div>
              <div style="color:var(--danger);">已设置组长个人绩效比例范围0~10%</div>
              <!--              管理列表设置获取-->
            </el-form-item>
            <el-form-item label="团队绩效比例">
              <div>
                <el-input-number
                  v-model="form.userName"
                  placeholder="请输入团队绩效比例"
                ></el-input-number
                >&nbsp;&nbsp;%
              </div>
              <div style="color:var(--danger);">已设置组长团队绩效比例范围0~10%</div>
            </el-form-item>
            <el-form-item label="新用户开卡奖励">
              <div>
                <el-input-number
                  v-model="form.userName"
                  placeholder="请输入新用户开卡奖励"
                ></el-input-number
                >&nbsp;&nbsp;元
              </div>
              <div style="color:var(--danger);">
                已设置组长新用户开卡奖励范围0~10元
              </div>
            </el-form-item>
          </el-card>
        </el-form-item>
        <el-form-item label="试用组员">
          <el-card shadow="never">
            <el-form-item label="姓名">
              <el-select
                v-model="form.status"
                placeholder="请选择销售经理"
                clearable
                filterable
              >
                <el-option label="正常" :value="0"></el-option>
                <el-option label="冻结" :value="1"></el-option>
                <el-option label="锁定" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="个人绩效比例">
              <div>
                <el-input-number
                  v-model="form.userName"
                  placeholder="请输入个人绩效比例"
                ></el-input-number
                >&nbsp;&nbsp;%
              </div>
              <div style="color:var(--danger);">已设置组长个人绩效比例范围0~10%</div>
              <!--              管理列表设置获取-->
            </el-form-item>
            <el-form-item label="团队绩效比例">
              <div>
                <el-input-number
                  v-model="form.userName"
                  placeholder="请输入团队绩效比例"
                ></el-input-number
                >&nbsp;&nbsp;%
              </div>
              <div style="color:var(--danger);">已设置组长团队绩效比例范围0~10%</div>
            </el-form-item>
            <el-form-item label="新用户开卡奖励">
              <div>
                <el-input-number
                  v-model="form.userName"
                  placeholder="请输入新用户开卡奖励"
                ></el-input-number
                >&nbsp;&nbsp;元
              </div>
              <div style="color:var(--danger);">
                已设置组长新用户开卡奖励范围0~10元
              </div>
            </el-form-item>
          </el-card>
        </el-form-item>
      </template>

      <el-form-item label="说明" prop="particularDesc">
        <el-input
          placeholder="请输入"
          type="textarea"
          v-model="form.particularDesc"
          maxlength="100"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="sure">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style scoped lang="scss">
::v-deep .el-card {
  height: 100% !important;
  padding: 0px !important ;
  .el-card__body {
    padding: 10px 20px;
  }
}
.el-input,
.el-select,
.el-textarea {
  width: 300px !important;
}
.el-input-number {
  width: 200px !important;
}
</style>
